import {
    getPriInputDlgSession,
    getCompressedFieldDataSet,
    getConnection
} from '../../../_shared/GWTBridge/invoke/procMain';
import {buildServerCall} from '../../../services/wcfService';

export function procParamChoose(field) {
    const methodName = 'ProcParamChoose';
    const reason = 'Open procedure choose';
    const session = getPriInputDlgSession();
    const xml = getCompressedFieldDataSet();
    const parameters = {session: [session], field: [field.toString()], xml: [xml]};
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}

export function procParamSearch(
    field: number,
    searchQuery: string = '',
    action: number,
    stackCursor: string,
    searchStart: string
) {
    const methodName = 'ProcParamSearch';
    const reason = 'Open procedure search';
    const session = getPriInputDlgSession();
    const xml = getCompressedFieldDataSet();
    const parameters = {
        session: [session],
        field: [field.toString()],
        mode: [action.toString()],
        cursor: [stackCursor],
        start: [searchStart],
        last: [''],
        editvalue: [searchQuery],
        xml: [xml]
    };
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}

export function procParamSearchNextPage(
    field: number,
    searchQuery: string = '',
    page: number,
    stackCursor: string,
    searchStart: string
) {
    const methodName = 'ProcParamSearchPage';
    const reason = 'Proc search scroll';
    const session = getPriInputDlgSession();
    const parameters = {
        session: [session],
        field: [field.toString()],
        page: [page.toString()],
        cursor: [stackCursor],
        start: [searchStart],
        last: [''],
        editvalue: [searchQuery]
    };
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
